import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TamasAlunoService } from '../tamas-aluno.service';

@Component({
  selector: 'app-me-inboxchat',
  templateUrl: './me-inboxchat.component.html',
  styleUrls: ['./me-inboxchat.component.css']
})
export class MeInboxchatComponent implements OnInit, OnDestroy {

  @ViewChild("inputSearch") meuinputSearch: ElementRef;
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;
  @ViewChild('inputTxtMsg') inputTxtMsg: ElementRef;

  hideCL: boolean = false;
  inputsearch: any = '';
  modoBusca: boolean = false;
  usuarioChat: any = '';
  qIdx: any = 0;
  qSki: any = 0;
  arrMsgs: any[] = [];
  fakeArrMsgs: any[] = [];
  realArrMsgs: any[] = [];
  intervalChat: any = '';
  txtmsg: any = '';
  canScroll: any = true;
  scrollMax: any = 0;
  scrollLO: any = 0;
  qtyNewMsg: any = 0;
  noMoreOld: boolean = false;
  chatUserNome: any = '';
  chatUserFoto: any = '';
  urlFoto: any = '';
  idLastV: any = 0;
  alreadyV: boolean = false;
  loaderMore: boolean = false;
  inLoad: boolean = false;
  userBlock: boolean = false;
  userBlockO: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public dialog: MatDialog, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    //this.hideCL = true;
    this.usuarioChat = this.route.snapshot.paramMap.get('nomeusuario');

    this.carregarMsgs();
  }

  ngOnDestroy() {
    clearInterval(this.intervalChat);
  }

  ngAfterViewChecked() {
    if (this.canScroll) {
      this.scrollToBottom();
    }
    else {
      console.log("cant scroll");
    }

  }


  desbloquearU(): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      nomeusuario: this.usuarioChat
    };
    this.tmaService.unblockUserChat(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.userBlock = false;
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })
  }
  bloquearU(): void {
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      nomeusuario: this.usuarioChat
    };
    this.tmaService.blockUserChat(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.userBlock = true;
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })
  }


  onScroll(event): void {
    console.log("scroll utilizado");
    //comparar altura
    let tracker = event.target;
    //console.log(tracker);
    console.log(tracker.clientHeight);
    console.log("SH " + tracker.scrollHeight);
    // console.log(tracker.scrollTop);
    //console.log(this.myScrollContainer.nativeElement.scrollHeight);
    //console.log(tracker.scrollTop);
    console.log("ST " + this.myScrollContainer.nativeElement.scrollTop);
    console.log("SM " + this.scrollMax);
    if (tracker.scrollTop == this.scrollMax) {
      //end
      this.canScroll = true;
      this.qtyNewMsg = 0;
    }
    else {
      this.canScroll = false;
    }



    //load more

    if ((tracker.clientHeight - tracker.scrollHeight) == this.myScrollContainer.nativeElement.scrollTop) {
      //load old msg
      console.log("load old");
      this.qIdx = 20;
      if (!this.noMoreOld) {
        if (!this.inLoad) {
          //se for true significa que já está carregando
          this.carregarOldMsg();
        }

      }
    }

    if (tracker.scrollTop == 0) {


    }

    //aqui tá invertido só é 0 quando rola até o final (pra baixo)
    // if(tracker.scrollTop == 0){
    //   //load old msg
    //   console.log("load old");
    //   this.qIdx = 20;
    //   if(!this.noMoreOld){
    //     if(!this.inLoad){
    //       //se for true significa que já está carregando
    //       this.carregarOldMsg();
    //     }

    //   }

    // }
  }

  scrollToBottom(): void {
    try {
      this.canScroll = true;
      this.qtyNewMsg = 0;
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
      this.scrollMax = this.myScrollContainer.nativeElement.scrollTop;
      //console.log(this.scrollMax);
      //console.log("scroll ", this.myScrollContainer.nativeElement.scrollTop);
    } catch (err) { }
  }
  voltar() {
    // this.router.navigate(['/me/inbox']);
    if(this.tmaService.paginaAnterior != ''){
      this.router.navigate([this.tmaService.paginaAnterior]);
    }
    else{
      this.router.navigate(['/home']);
    }
    
    //this._location.back();
    // if(this.modoBusca){
    //   this.modoBusca = false;
    // }
    // else{
    //   this._location.back();
    // }

  }


  enviarMsg() {
    //primeiro adiciona no array para parecer q já foi enviado, depois faz o serverside

    if (this.userBlock) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { tituloAlerta: "Aviso", textoAlerta: "Você bloqueou este usuário. Para enviar mensagens é necessário desbloqueá-lo", iconAlerta: 'warning' }
      })
    }

    if (this.userBlockO) {
      const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        disableClose: true,
        data: { tituloAlerta: "Aviso", textoAlerta: "Não é possível enviar mensagens para este usuário", iconAlerta: 'warning' }
      })
    }

    if (this.txtmsg != '' && this.userBlock == false && this.userBlockO == false) {
      this.canScroll = true;
      this.fakeArrMsgs.unshift({ msg: this.txtmsg, h: '', me: true });
      var nMsg = this.txtmsg;
      this.txtmsg = '';
      //return false;
      //this.arrMsgs = this.fakeArrMsgs;
      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        nickchat: this.usuarioChat,
        msg: nMsg
      };
      this.tmaService.addNewMessageChat(customParams).subscribe((qRes) => {
        //this.hideCL = true;
        console.log(qRes);
        if (qRes['res'] == 'done') {
          console.log("msg enviada");
          //this.txtmsg = '';
          clearInterval(this.intervalChat);
          this.brokerInChat();
          this.intervalChat = setInterval(() => {
            this.brokerInChat();
          }, 15000);
        }
        else {
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
          })
        }
      },
        (error) => {
          this.hideCL = true;
          const erroCriar = this.dialog.open(AlertaSimplesDialog, {
            disableClose: true,
            data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
          });
        })
    }
  }


  brokerInChat() {
    console.log("broaker called");

    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      i: this.qIdx,
      nickchat: this.usuarioChat
    };
    this.tmaService.brokerMsg(customParams).subscribe((qRes) => {
      //this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.alreadyV = true;
        if (qRes['msgs'] != '') {
          this.fakeArrMsgs = [];
          var novasMsg = qRes['msgs'];
          this.qSki += novasMsg.length;
          if (!this.canScroll) {
            this.qtyNewMsg += novasMsg.length;
            if (this.qtyNewMsg > 9) {
              this.qtyNewMsg = 9;
            }
          }
          novasMsg.reverse();
          novasMsg.forEach(element => {
            this.arrMsgs.unshift({ id: element.id, msg: element.msg, dt: element.dt, h: element.h, me: element.me });
          });

          this.msgDtArrange();
          // this.arrMsgs = [];
          // this.arrMsgs = this.realArrMsgs;
          //this.fakeArrMsgs = this.realArrMsgs;
        }

        //this.arrMsgs = qRes['msgs'];

        //this.buscarInfoUser(this.tmaService.hcNomeUsuario);
      }
      else {
        // const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        //   disableClose: true,
        //   data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        // })
      }
    },
      (error) => {
        this.hideCL = true;
        // const erroCriar = this.dialog.open(AlertaSimplesDialog, {
        //   disableClose: true,
        //   data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        // });
      })
  }


  carregarOldMsg() {
    //this.hideCL = false;
    this.loaderMore = true;
    this.inLoad = true;
    clearInterval(this.intervalChat);
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      i: this.qSki,
      nickchat: this.usuarioChat
    };
    this.tmaService.listarMsgsOld(customParams).subscribe((qRes) => {
      //this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        this.loaderMore = false;
        this.inLoad = false;
        //this.realArrMsgs = qRes['msgs'];
        //this.arrMsgs = qRes['msgs'];
        var novasMsg = qRes['msgs'];
        this.qSki += novasMsg.length;
        if (novasMsg.length == 0) {
          this.noMoreOld = true;
        }
        // if(!this.canScroll){
        //   this.qtyNewMsg += novasMsg.length;
        //   if(this.qtyNewMsg > 9){
        //     this.qtyNewMsg = 9;
        //   }
        // }
        //novasMsg.reverse();
        novasMsg.forEach(element => {
          this.arrMsgs.push({ id: element.id, msg: element.msg, dt: element.dt, h: element.h, me: element.me });
        });

        this.msgDtArrange();
        //this.fakeArrMsgs = qRes['msgs'];
        //iniciar o interval
        clearInterval(this.intervalChat);
        this.intervalChat = setInterval(() => {
          this.brokerInChat();
        }, 20000);
        //this.buscarInfoUser(this.tmaService.hcNomeUsuario);
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.inLoad = false;
        //this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })
  }
  carregarMsgs() {
    console.log(this.fakeArrMsgs);
    console.log(this.fakeArrMsgs.length);
    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      i: this.qIdx,
      nickchat: this.usuarioChat
    };
    this.tmaService.listarMsgs(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        //this.realArrMsgs = qRes['msgs'];
        if (qRes['msg'] != '') {
          this.arrMsgs = qRes['msgs'];
        }
        else {
          this.arrMsgs = [];
        }


        //check if msg is link
        // this.arrMsgs.forEach((item, index) => {
        //   if(item.contains("https")){

        //   }
        // });

        this.chatUserNome = qRes['nome'];
        this.chatUserFoto = qRes['foto'];

        if (qRes['blockM'] != null) {
          this.userBlock = qRes['blockM']
        }
        if (qRes['blockO'] != null) {
          this.userBlockO = qRes['blockO']
        }

        this.idLastV = qRes['lastV'];
        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
        this.qSki = this.arrMsgs.length;
        if (this.qIdx == 0) {
          this.scrollToBottom();
        }

        this.msgDtArrange();
        //iniciar o interval
        clearInterval(this.intervalChat);
        this.intervalChat = setInterval(() => {
          this.brokerInChat();
        }, 20000);
        //console.log(orderInvert.reverse());

        //this.fakeArrMsgs = qRes['msgs'];

        //this.buscarInfoUser(this.tmaService.hcNomeUsuario);
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })
  }

  msgDtArrange() {
    //primeiro setar tudo pra false
    this.arrMsgs.map(x => {
      x.exibeData = false;
    });

    var uniqueItems = Array.from(new Set(this.arrMsgs.map(item => item.dt)));
    console.log(uniqueItems);
    var orderInvert = this.arrMsgs.slice().reverse();
    //orderInvert.reverse();
    uniqueItems.forEach(item => {
      var qItem = orderInvert.find(x => x.dt == item);
      var arrItem = this.arrMsgs.find(x => x.id == qItem.id);
      arrItem.exibeData = true;
    });
    console.log(this.arrMsgs);
  }

  onBlur(event) {
    if (/Macintosh|iPad|iPhone/.test(window.navigator.userAgent)) {
      //qUserAgent = "iOS";
    }
    else {
      this.inputTxtMsg.nativeElement.focus();
      //atualizar a altura do scroll - pq no mobile quando a adressbar aparece, fica diferente a altura
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
      this.scrollMax = this.myScrollContainer.nativeElement.scrollTop;
    }



  }

  digitando(textoBusca: any): void {

  }
  ativarBusca(): void {
    this.modoBusca = true;
    setTimeout(() => { // this will make the execution after the above boolean has changed
      this.meuinputSearch.nativeElement.focus();
    }, 300);
  }
  buscaFim(): void {
    setTimeout(() => {
      this.modoBusca = false;
    }, 100);
  }


  goPerfilUser(): void {
    this.tmaService.gUrlAnterior = '/me/inbox';
    this.router.navigate(['/' + this.usuarioChat]);
  }
  verMsg(idConversa: any): void {
    const atendimentOffDialog = this.dialog.open(AlertaSimplesDialog, {
      disableClose: true,
      data: { textoAlerta: "Implementação pendente...", iconAlerta: 'warning' }
    })
  }
}
